<template>
  <b-navbar type="light" toggleable="xl" fixed="top" class="header-area p-0" :class="{ 'is-sticky': scrolled }">
    <div class="container-fluid container-fluid--cp-150 position-relative">
      <b-navbar-toggle target="nav_collapse" class="d-none"></b-navbar-toggle>
      <b-link href="/">
        <b-navbar-brand class="logo-mobile mx-0 px-2">
          <img src="../assets/img/logo/logo.png" alt="mhp-finance.de Logo">
        </b-navbar-brand>
      </b-link>
      <b-btn-group class="header-config-wrapper px-2">
        <b-link class="ht-btn ht-btn--outline hire-btn d-none d-xl-block" :href="webappUrl" target="_blank">Register-Login
        </b-link>
        <b-link class="mobile-menu-bar d-xl-none" @click="mobiletoggleClass('addClass', 'active')">
          <fa-icon :icon="['fas', 'bars']" />
        </b-link>
      </b-btn-group>
      <b-collapse class="default-nav justify-content-center position-relative" is-nav id="nav_collapse">
        <b-navbar-nav class="navbar-nav main-menu element-menu">
          <b-nav-item @click="scrollTo('home')"><span>Start</span></b-nav-item>
          <b-nav-item>
            <b-link :to="{ name: 'Gallery' }"><span>Galerie</span></b-link>
          </b-nav-item>
          <b-nav-item>
            <b-link :to="{ name: 'Shop' }"><span>Shop</span></b-link>
          </b-nav-item>
          <b-nav-item-dropdown text="Unsere Leistungen">
            <b-dropdown-item @click="scrollTo('offer')">Unser Angebot</b-dropdown-item>
            <b-dropdown-item @click="scrollTo('clients')">für exklusiv-Kunden</b-dropdown-item>
            <b-dropdown-item @click="scrollTo('merchants')">für Händler</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item @click="scrollTo('contact')"><span>Kontakt</span></b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </div>
  </b-navbar>
</template>

<script>
import ScrollTo from './mixins/scrollTo.js'
import { webappUrl } from '@/config.js'

export default {
  name: 'HeaderElement',
  mixins: [ScrollTo],
  data() {
    return {
      load: false,
      limitPosition: 200,
      scrolled: false,
      lastPosition: 500,
      webappUrl
    }
  },
  methods: {
    // sticky menu script
    handleScroll() {
      if (this.lastPosition < window.scrollY && this.limitPosition < window.scrollY) {
        this.scrolled = true;
        // move up!
      }
      if (this.lastPosition > window.scrollY) {
        this.scrolled = true;
        // move down
      }
      this.lastPosition = window.scrollY;
      this.scrolled = window.scrollY > 80;
    },

    // mobile toggle
    mobiletoggleClass(addRemoveClass, className) {
      const el = document.querySelector('#offcanvas-menu');
      if (addRemoveClass === 'addClass') {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  }
}
</script>

<style lang="scss">
.mobile-menu-bar {
  color: #b99a61;
  font-size: 25px;
  padding: 8px 10px 10px;
  line-height: 1;
  height: 42px;
  margin-top: 6px;
  border-radius: 4px;
}

.element-menu {
  [aria-expanded="false"] {
    background-color: transparent;
  }

  .dropdown-item {
    font-size: 14px;

    &:hover {
      color: #b99a61;
      background-color: transparent;
    }
  }

  .dropdown-menu {
    border: none;
    border-bottom: 3px solid #b99a61;
    margin-top: -2px;
  }
}

.mega-menu {
  .dropdown-menu {
    min-width: 100%;
  }

  .mega-submenu {
    width: 33.33%;
    float: left;

    .nav-link {
      padding: 20px 10px !important;

      .mega-title {
        .dropdown-item {
          font-weight: 500;
          color: #000;
        }

      }
    }
  }
}
</style>